import { Link } from "react-router-dom";
import { Instagram, Youtube, Music2, MapPin, Phone, Mail, ExternalLink } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SCHRIFTZUG, LAT_LOGO, SOCIALS, CONTACT } from "@/lib/media";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-hell-black" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-6 mb-5 flex-wrap">
            <img src={SCHRIFTZUG} alt="Krampus Show" className="h-12 w-auto" />
            <a href={CONTACT.website} target="_blank" rel="noreferrer" data-testid="footer-lat-logo">
              <img src={LAT_LOGO} alt="Latschenwirt" className="h-14 md:h-16 w-auto brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" />
            </a>
          </div>
          <p className="text-hell-smoke text-sm max-w-sm">{t("footer_tagline")}</p>
          <div className="flex gap-3 mt-6">
            <a data-testid="social-instagram" href={SOCIALS.instagram} target="_blank" rel="noreferrer"
              className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-hell-bone/70 hover:text-hell-gold hover:border-hell-gold/50 transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a data-testid="social-youtube" href={SOCIALS.youtube} target="_blank" rel="noreferrer"
              className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-hell-bone/70 hover:text-hell-gold hover:border-hell-gold/50 transition-colors">
              <Youtube className="w-4 h-4" />
            </a>
            <a data-testid="social-tiktok" href={SOCIALS.tiktok} target="_blank" rel="noreferrer"
              className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-hell-bone/70 hover:text-hell-gold hover:border-hell-gold/50 transition-colors">
              <Music2 className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-cinzel text-xs tracking-[0.3em] uppercase text-hell-gold mb-5">{t("footer_explore")}</h4>
          <ul className="space-y-3 text-sm text-hell-bone/70">
            <li><Link data-testid="footer-tickets" to="/tickets" className="hover:text-hell-gold transition-colors">{t("nav_tickets")}</Link></li>
            <li><Link data-testid="footer-anreise" to="/anreise" className="hover:text-hell-gold transition-colors">{t("nav_travel")}</Link></li>
            <li><Link data-testid="footer-sponsors" to="/sponsoren" className="hover:text-hell-gold transition-colors">{t("nav_sponsors")}</Link></li>
            <li><Link data-testid="footer-press" to="/presse" className="hover:text-hell-gold transition-colors">{t("nav_press")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-cinzel text-xs tracking-[0.3em] uppercase text-hell-gold mb-5">{t("footer_contact")}</h4>
          <ul className="space-y-3 text-sm text-hell-bone/70">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-hell-ember shrink-0" />{CONTACT.address}</li>
            <li><a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-hell-gold transition-colors"><Phone className="w-4 h-4 text-hell-ember" />{CONTACT.phone}</a></li>
            <li><a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-hell-gold transition-colors"><Mail className="w-4 h-4 text-hell-ember" />{CONTACT.email}</a></li>
            <li><a data-testid="footer-website" href={CONTACT.website} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-hell-gold transition-colors"><ExternalLink className="w-4 h-4 text-hell-ember" />latschenwirt.at</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-hell-bone/40 font-cinzel tracking-[0.25em] uppercase">
        {t("footer_legal")} · © {new Date().getFullYear()} Latschenwirt ·{" "}
        <Link data-testid="footer-impressum" to="/impressum" className="hover:text-hell-gold transition-colors">Impressum</Link> ·{" "}
        <Link data-testid="footer-datenschutz" to="/datenschutz" className="hover:text-hell-gold transition-colors">{t("legal_privacy")}</Link> ·{" "}
        <Link data-testid="footer-agb" to="/agb" className="hover:text-hell-gold transition-colors">AGB</Link> ·{" "}
        <Link data-testid="footer-widerruf" to="/widerruf" className="hover:text-hell-gold transition-colors">{t("legal_widerruf")}</Link>
      </div>
    </footer>
  );
}
